import { PaginatedResponseModel } from '@abb-procure/data';
import type { NotificationInboxViewResponse } from '../types/notification-inbox-view-response.type';
import { NotificationInboxMessageModel } from './notification-inbox-message.model';

export class NotificationInboxViewResponseModel
  extends PaginatedResponseModel
  implements NotificationInboxViewResponse
{
  items: NotificationInboxMessageModel[] | null = null;
  readonly filteredCount: number;
  readonly unreadCount: number;

  constructor(data: NotificationInboxViewResponse) {
    super(data);

    this.items = data.items
      ? data.items.map((message) => new NotificationInboxMessageModel(message))
      : null;

    this.filteredCount = data.filteredCount;
    this.unreadCount = data.unreadCount;
  }
}
